import { BlockStack, Button, ButtonGroup, Card, Form, FormLayout, InlineGrid, InlineStack, LegacyStack, Page, TextField } from "@shopify/polaris";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { CountrySelector, StateSelector } from "../Selectors";
import Api from "../../helpers/api";

const Dropship = props => {
    const history = useHistory();
    const {customerid} = useParams();

    const [locationId, setLocationId] = useState(null);
    const [form, setForm] = useState({
        'first_name': '',
        'last_name': '',
        'address1': '',
        'address2': '',
        'city': '',
        'zip': '',
        'country': 'US',
        'state': '',
    })
    const [errors, setErrors] = useState({});

    useEffect(() => {
        Api.getLocations(customerid).then(({data}) => {
            setLocationId(data?.data[0]?.id);
        });
    }, [])

    const updateForm = useCallback((key, value) => {
        setForm({
            ...form, 
            [key]: value
        })
    }, [form]);

    const handleSubmit = () => {
        Api.storeDropshipAddress(form).then(({data}) => {
            console.log('Destination', `/orders/${customerid}?location_id=${locationId}&dropship=${data.key}`);
            history.push(`/orders/${customerid}?location_id=${locationId}&dropship=${data.key}`);
        }).catch(error => {
            if ( error.response.status === 422 ) {
                const data = error.response.data; 
                setErrors(Object.keys(data.errors).reduce((prev, current) => {
                    return {...prev, [current]: data.errors[current][0]}
                }, {}))
            }
        });
    };

    return (
        <Page
            title="Create Dropship Order"
            breadcrumbs={[{
                content: "Back to Customer",
                onAction() {
                    history.push('/customers/'  + customerid );
                }
            }]}
            >
            <Card title="Dropship Address">
                <BlockStack gap={200}>
                    <Form onSubmit={handleSubmit}>
                        <FormLayout>
                        <InlineGrid gap={400} columns={2}>
                            <TextField label="First Name" onChange={(value) => {updateForm('first_name', value)}} value={form.first_name} error={errors?.first_name} />
                            <TextField label="Last Name" onChange={(value) => {updateForm('last_name', value)}} value={form.last_name} error={errors?.last_name} />
                        </InlineGrid>
                        <TextField label="Address 1" onChange={(value) => {updateForm('address1', value)}} value={form.address1} error={errors?.address1} />
                        <TextField label="Address 2" onChange={(value) => {updateForm('address2', value)}} value={form.address2} error={errors?.address2} />
                        <InlineGrid gap={200} columns={2}>
                            <TextField label="City" onChange={(value) => {updateForm('city', value)}} value={form.city} error={errors?.city} />
                            <TextField label="Zipcode" onChange={(value) => {updateForm('zip', value)}} value={form.zip} error={errors?.zip} />
                        </InlineGrid>
                        <CountrySelector value={form.country} onChange={(value) => {updateForm('country', value)}} error={errors?.country} />
                        <StateSelector value={form.state} onChange={(value) => {updateForm('state', value)}} selectedCountry={form.country} error={errors?.state} />
                        </FormLayout>
                    </Form>
                    <InlineStack align="end">
                        <ButtonGroup>
                            <Button onClick={handleSubmit} submit variant="primary"> Place Order</Button>
                        </ButtonGroup>
                    </InlineStack>
                </BlockStack>
            </Card>
        </Page>
    )
}

export default Dropship;